<div class="jumbotron" style="background-image: url('/assets/images/{{imageUrl}}');">
  <ng-container *ngIf="headingText">
    <div class="row h-100">
      <div class="col-12 text-center text-white m-y-auto">
        <h1>{{headingText}}</h1>
      </div>
    </div>
  </ng-container>
</div>
